export default "__VITE_ASSET__f0cf8c8a__"